/**
 * 「历史牌局」在大厅里的入口。与 `EmailAuthEntry.tsx` 同一套
 * 「hook 管开关 + 入口 + 面板」结构，面板本体在 `history/HistoryPanel.tsx`。
 */
import { useCallback, useState } from 'react'
import type { ReactNode } from 'react'

import { HistoryPanel } from '../history/HistoryPanel.js'

export interface HistoryEntryState {
  readonly open: boolean
  show(): void
  close(): void
}

export function useHistoryEntry(): HistoryEntryState {
  const [open, setOpen] = useState(false)
  return {
    open,
    show: useCallback(() => setOpen(true), []),
    close: useCallback(() => setOpen(false), []),
  }
}

export function HistoryFindEntry({ onOpen }: { onOpen(): void }): ReactNode {
  return (
    <button type="button" className="lobby-btn lobby-btn--ghost" onClick={onOpen}>
      历史牌局
    </button>
  )
}

export function HistorySheet({ state }: { readonly state: HistoryEntryState }): ReactNode {
  if (!state.open) return null
  return <HistoryPanel onClose={state.close} />
}
